const DeleteAccount = () => {
  return (
    <>
      <h3 class="ct_fs_32 ct_switzer_bold mb-5">Delete Account</h3>
      <div class="d-flex align-items-center justify-content-between gap-3">
        <p class="mb-0 ct_text_4f4f4f">
          This will delete your account and all associated information.
        </p>
        <a
          href="javascript:void(0)"
          class="text-dark ct_switzer_Semibold ct_fw_600 ct_white_nowrap"
          // data-bs-toggle="modal"
          // data-bs-target="#otpDeleteModal"
          data-bs-toggle="modal"
          data-bs-target="#mobileAppModal"
        >
          <u>Delete</u>
        </a>
      </div>

      <div
        class="modal fade otp-modal"
        id="otpDeleteModal"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            {/* Close */}
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>

            {/* Icon */}
            <div class="otp-icon-wrap">
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                  stroke="#16a34a"
                  stroke-width="2"
                />
                <path
                  d="M20 21C20 17.134 16.4183 14 12 14C7.58172 14 4 17.134 4 21"
                  stroke="#16a34a"
                  stroke-width="2"
                />
                <path
                  d="M19 8L22 11M22 8L19 11"
                  stroke="#16a34a"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            {/* Title */}
            <h5 class="ct_fs_24 ct_fw_500">OTP to confirm deletion</h5>

            {/* Subtitle */}
            <p class="ct_text_clr_4B5563">
              A 4-digit code has been sent to +91 (987)-654-3210
            </p>

            {/* OTP Inputs */}
            <div class="otp-inputs">
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
            </div>

            {/* CTA */}
            <button class="ct_green_bnt w-100">Delete my account</button>

            {/* Resend */}
            <p class="otp-resend mt-3">
              Didn’t receive OTP?
              <a href="#" class="ct_green_text">
                Resend Code
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;
